(function($, window, undefined) {
  $(window).ready(function() {
    /* Next button */
    $('#UploadImages').on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      $('.product-info').addClass('hidden');
      $('#UploadImages').addClass('hidden');
      $('.product-upload-images').removeClass('hidden');
      if (window.getQueryParam('updatecart') == 1) {
        $('#UpdateCartItem').removeClass('hidden');
      } else {
        $('#AddToCart').removeClass('hidden');
      }

      // Show the uploader larger for certain product types
      if (window.productType == "Guest Books" || window.productType == "Journals") {
        $('.product-single__hero .grid__item').removeClass('post-large--one-half');
        $('.product-single__hero .grid__item').eq(1).addClass('text-center');
        $('.product-single__hero .grid__item').eq(1).find('.selector-wrapper select').css('margin', '0 auto 1em');
        $(window).scrollTop(0);
      }
    });

    /* Portrait/Landscape toggle */
    $('.product-customizer-option[data-option-name="orientation"]').find('select').on('change', function(event) {
      var $this = $(this);

      if ($this.val() == 'Landscape') {
        $('.product-image').each(function() {
          $(this).addClass('landscape');
        });
      } else {
        $('.product-image').each(function() {
          $(this).removeClass('landscape');
        });
      }

      window.fspUtils.updateImageScalesForMultipartProduct(window.uploadCount, $('#upload-part0').hasClass('landscape'));
    });

    /* Show/Hide instructions button */
    $('body').on('click', 'button.show-hide-instructions', function(event) {
      $('#product-images img.instructions').toggleClass('hidden');
    });

    /* Upload artwork button */
    $('body').on('click', 'button.upload-artwork', function(event) {
      if (!window.customerId) {
        //$('#login-modal').addClass('visible');
        $('#login-modal').trigger('show');
        return;
      }
      var $button = $(this);
      filepicker.pick(
        {
          mimetypes: ['image/*', 'application/postscript', 'application/pdf'],
          container: 'window',
          services: ['COMPUTER', 'GOOGLE_DRIVE', 'DROPBOX']
        },
        function(blob) {
          var handle = blob.url;
          var pos = handle.lastIndexOf('/');
          if (pos >= 0) {
            handle = handle.substring(pos + 1);
          }
          if (!handle) {
            console.error('Invalid response returned from filestack picker');
            return;
          }

          var ext = blob.filename;
          pos = ext.lastIndexOf('.');
          if (pos >= 0) {
            ext = ext.substring(pos);
          }

          var $parent = $button.closest('.product-image-instruction-wrapper');
          if (!$parent.length) {
            $parent = $button.closest('.product-image-instruction');
          }
          var index = $parent.data('index');
          var productId = $button.closest('.product-upload-images').data('product-id');
          var filename = productId + '_part' + index + ext;
          $.ajax({
            method: 'GET',
            url: 'https://process.filestackapi.com/store=filename:' + filename + '/' + handle
          })
          .done(function(blobNew) {
            window.openUploadLibrary(
              {
                url: blobNew.url,
                previewUrl: window.fspUtils.cacheAndConvertFileStackUrlToJpg(blobNew.url),
                client: blob.client,
                filename: blob.filename,
                mimetype: blob.mimetype,
              },
              function(url, client) {
                // Set line item property
                $('#product-image' + index).val(blobNew.url);
                $('#product-image-client' + index).val(client);

                var usePageIndex = !!window.multipartImages[index].pageCount;
                var filestackId = url.substr(url.lastIndexOf('/') + 1);

                if (usePageIndex) {
                  var $vdControls = $('.product-vd-controls');

                  $vdControls.data('index', index).data('page', 1).removeClass('hidden');

                  $('.product-vd-controls .page-info .page-number').text('1');

                  $.ajax({
                    method: 'GET',
                    url: 'https://process.filestackapi.com/output=docinfo:true/' + filestackId,
                    contentType: 'application/json',
                    success: function(response) {
                      if (response.numpages > 0) {
                        $('.product-vd-controls .page-info .page-count').text(response.numpages);

                        $vdControls.data('maxpages', response.numpages);
                      }
                    }
                  })
                }

                // Show image
                window.fspUtils.setImageForMultipartProduct(
                  index,
                  window.fspUtils.cacheAndConvertFileStackUrlToJpg(url),
                  $('#upload-part' + index).hasClass('landscape')
                );
                // Show image on multi upload thumb
                var $thumb = $('#product-image-thumb' + index);
                if ($thumb.length > 0) {
                  $thumb.css('background-image', 'url(' + url + ')').addClass('uploaded');
                }
              }
            );
          })
          .error(function(error) {
            console.error(error);
            console.error('Uploaded file but failed to change name');
          });
        },
        function(FPError) {
          console.log(FPError.toString());
        }
      );
    });

    /* Alternative Trim overlay image support for Round corners option */
    var $roundedCornersSelect = window.fspUtils.getRoundedCornersSelect();
    if (
      $roundedCornersSelect.length > 0 &&
      (!window.trimOverlayImages.base || !window.trimOverlayImages.rounded)
    ) {
      console.warn('Both base and rounded version of trim overlay image should be available to provide rounded corners support');
    } else {
      $roundedCornersSelect.on('change', function() {
        if (!window.trimOverlayImages.base || !window.trimOverlayImages.rounded) {
          return;
        }

        if ($(this).val().toLowerCase() == 'yes') {
          $('img.trim').attr('src', window.trimOverlayImages.rounded);
        } else {
          $('img.trim').attr('src', window.trimOverlayImages.base);
        }
      });
    }

    /* Product image upload show by clicking thumb (product-filestack-triple template) */

    function showSlot(index) {
      $('.multi-uploads .upload-panel').addClass('hidden');
      $('#product-image-upload-panel' + index).removeClass('hidden');
    }

    $('body').on('click', '.product-image-thumbs .product-image-thumb', function(event) {
      event.preventDefault();

      var $this = $(this);
      var index = $this.data('index');

      showSlot(index);
      window.fspUtils.updateImageScaleForMultipartProduct(index, $('#upload-part' + index).hasClass('landscape'));
    });

    // Show first upload panel
    showSlot(0);

    /* Set correct number of upload slots to visible when single-sided selected by default */
    var $sideSelect = window.fspUtils.getSideSelect();
    if ($sideSelect && $sideSelect.length) {
      $sideSelect.on('change', window.fspUtils.changeMultipleUploadSlotCount);
      window.fspUtils.changeMultipleUploadSlotCount();
    }

    /* Select from library button */
    $('body').on('click', 'button.select-from-library', function(event) {
      if (!window.customerId) {
        //$('#login-modal').addClass('visible');
        $('#login-modal').trigger('show');
        return;
      }

      var $button = $(this);

      window.openSelectFromLibraryModal(function(url) {
        var $parent = $button.closest('.product-image-instruction-wrapper');
        if (!$parent.length) {
          $parent = $button.closest('.product-image-instruction');
        }
        var index = $parent.data('index');
        var usePageIndex = !!window.multipartImages[index].pageCount;
        var filestackId = url.substr(url.lastIndexOf('/') + 1);

        if (usePageIndex) {
          var $vdControls = $('.product-vd-controls');

          $vdControls.data('index', index).data('page', 1).removeClass('hidden');

          $('.product-vd-controls .page-info .page-number').text('1');

          $.ajax({
            method: 'GET',
            url: 'https://process.filestackapi.com/output=docinfo:true/' + filestackId,
            contentType: 'application/json',
            success: function(response) {
              if (response.numpages > 0) {
                $('.product-vd-controls .page-info .page-count').text(response.numpages);

                $vdControls.data('maxpages', response.numpages);
              }
            }
          })
        }

        // Set line item property
        var orgUrl = 'https://cdn.filestackcontent.com/' + filestackId;
        $('#product-image' + index).val(orgUrl);
        $('#product-image-client' + index).val('library');
        // Show image
        window.fspUtils.setImageForMultipartProduct(
          index,
          window.fspUtils.cacheAndConvertFileStackUrlToJpg(url),
          $('#upload-part' + index).hasClass('landscape')
        );
        // Show image on multi upload thumb
        var $thumb = $('#product-image-thumb' + index);
        if ($thumb.length > 0) {
          $thumb.css('background-image', 'url(' + url + ')').addClass('uploaded');
        }
      });
    });

    $('.product-vd-controls .first').click(function(){
      var $controls = $('.product-vd-controls'),
        index = $controls.data('index'),
        page = 1,
        url = $('#product-image' + index).val();

      $controls.data('page', page);
      $('.product-vd-controls .page-info .page-number').text(page);

      window.fspUtils.setImageForMultipartProduct(
        index,
        window.fspUtils.cacheAndConvertFileStackUrlToJpg(url, page),
        $('#upload-part' + index).hasClass('landscape')
      );
    })

    $('.product-vd-controls .next').click(function(){
      var $controls = $('.product-vd-controls'),
        index = $controls.data('index'),
        page = Math.max($controls.data('page') + 1, 1),
        url = $('#product-image' + index).val();

      $controls.data('page', page);
      $('.product-vd-controls .page-info .page-number').text(page);

      window.fspUtils.setImageForMultipartProduct(
        index,
        window.fspUtils.cacheAndConvertFileStackUrlToJpg(url, page),
        $('#upload-part' + index).hasClass('landscape')
      );
    })

    $('.product-vd-controls .prev').click(function(){
      var $controls = $('.product-vd-controls'),
        index = $controls.data('index'),
        page = Math.min($controls.data('page') - 1, $controls.data('maxpages')),
        url = $('#product-image' + index).val();

      $controls.data('page', page);
      $('.product-vd-controls .page-info .page-number').text(page);

      window.fspUtils.setImageForMultipartProduct(
        index,
        window.fspUtils.cacheAndConvertFileStackUrlToJpg(url, page),
        $('#upload-part' + index).hasClass('landscape')
      );
    })

    $('.product-vd-controls .last').click(function(){
      var $controls = $('.product-vd-controls'),
        index = $controls.data('index'),
        page = $controls.data('maxpages'),
        url = $('#product-image' + index).val();

      $controls.data('page', page);
      $('.product-vd-controls .page-info .page-number').text(page);

      window.fspUtils.setImageForMultipartProduct(
        index,
        window.fspUtils.cacheAndConvertFileStackUrlToJpg(url, page),
        $('#upload-part' + index).hasClass('landscape')
      );
    })

    /*
     * Update button when editing cart item
     *
     * This button removes previous cart item and place new order with updated parameters
     */
    $('#UpdateCartItem').on('click', function(event) {

      // Check line parameter
      var line = window.getQueryParam('line');
      if (line < 1) {
        console.error('Invalid line parameter');
        return;
      }

      // Form validation
      if (!window.onCartFormSubmit(event)) {
        return;
      }

      var $btn = $(this);
      $btn.attr('disabled', true);

      // Now set old order quantity to 0
      $.ajax({
        method: 'POST',
        url: '/cart/change.js',
        data: {
          line: line,
          quantity: 0,
        },
        dataType: 'json',
      })
      .done(function(data) {
        var customized = window.getQueryParam('customized');
        if (customized == 'yes') {
          // Set old order customization product quantity to 0 (remove product-customizer app hidden orders)
          $.ajax({
            method: 'POST',
            url: '/cart/change.js',
            data: {
              line: line,
              quantity: 0,
            },
            dataType: 'json',
          })
          .done(function(data) {
            $('#AddToCartForm').submit();
          })
          .always(function() {
            $btn.attr('disabled', false);
          });
        }
        else {
          $('#AddToCartForm').submit();
        }
      })
      .always(function() {
        $btn.attr('disabled', false);
      });
    });

    /* Multiple upload template (named as triple template) 2nd slot visibility */
    function check2ndSlotVisibility() {
      var $slotLabel = $('.product-image-thumbs .product-image-thumb-wrapper').eq(1);
      var $slot = $('#product-image-upload-panel1');
      var singleOrDouble = window.fspUtils.getSingleOrDouble();

      if (singleOrDouble.substr(0, 6).toLowerCase() == 'double') {
        $slotLabel.removeClass('hidden');
        $slot.removeClass('hidden');
      } else {
        $slotLabel.addClass('hidden');
        $slot.addClass('hidden');

        if ($slot.attr('id') == 'product-image-upload-panel1') {
          // If 2nd slot was previously visible, we should show 1st slot as visible instead
          showSlot(0);
        }
      }
    }

    /* Visibilty handlers bind */
    var $singleOrDoubleSelect = window.fspUtils.getSingleOrDoubleSelect();
    if ($singleOrDoubleSelect) {
      $singleOrDoubleSelect.on('change', check2ndSlotVisibility);
    }
  });

  /* Validation on form submit */
  window.noticeTexts = {
    lunchboxUploadArtWorkNotice: 'Please upload artwork for lunchbox slots.',
    multipartsUploadArtWorkNotice: 'Please upload artwork for all areas.',
    tripleUploadArtWorkNotice: 'Please upload artwork for all slots.',
  };

  function addNoticeText(noticeText, noticeToAdd) {
    if (noticeText.length > 0) {
      noticeText += '<br />';
    }
    noticeText += '&#x25cf; ' + noticeToAdd;
    return noticeText;
  }

  /******************************************/
  /* fix product customizer */
  /* Could add blank customization options */
  /* This would skew total saved in cart */
//   var _addOptionPricingItemToCart = window.shopstorm.apps.productCustomizer.addOptionPricingItemToCart,
//       _addOptionPricingItemToCartLastArguments = [];

//   window.shopstorm.apps.productCustomizer.addOptionPricingItemToCart = function(){
//       _addOptionPricingItemToCartLastArguments = arguments;

//   // 	console.log('set args', arguments, _addOptionPricingItemToCart);
//   }
  /*******************************/
  /* end fix product customizer */
  /*****************************/

  window.onCartFormSubmit = function(event) {
    var validated = true;
    var noticeText = '';

    // Image upload validation
    if (window.productTemplate == 'filestack.lunchbox') {
      if (
        !$('#product-image0').val() ||
        !$('#product-image1').val() ||
        !$('#product-image2').val()
      ) {
        validated = false;
        noticeText = addNoticeText(noticeText, window.noticeTexts.lunchboxUploadArtWorkNotice);
      }
    } else if (window.productTemplate == 'filestack.multiparts') {
      $('#image-properties > .image-property:not(.prototype) > .product-image').each(function() {
        var $input = $(this);
        if (!$input.val()) {
          validated = false;
          noticeText = addNoticeText(noticeText, window.noticeTexts.multipartsUploadArtWorkNotice);
          return false;
        }
      });
    } else if (window.productTemplate == 'filestack.triple') {

      /*
      	TODO: Improve this (This is redunant if it is done correctly the first time)
        This is a fix to solve a problem that was occuring on triple 3/4 page foil products uploader...
        This updates the data-upload-count attribute to three as the default is 4
        This isn't currently update on change from double-single side <option> to single-sided... Janky fix
        - Shug
      */

      if ($("div.product-customizer-option.option-type-select[data-option-name='sides'] option:selected").val() === 'Single-sided'){
      	$('div.product-upload-images').data('upload-count', 3);
      }

      var index = 0;
      var count = window.fspUtils.visibleMultipleUploadSlotCount();
      $('#image-properties > .image-property:not(.prototype) > .product-image').each(function() {
        var $input = $(this);
        if (!$input.val()) {
          validated = false;
          noticeText = addNoticeText(noticeText, window.noticeTexts.tripleUploadArtWorkNotice);
          return false;
        }

        index += 1;
        if (index >= count) {
          return false;
        }
      });
    }

    if (!validated) {
      event.preventDefault();
      event.stopPropagation();

      if (noticeTexts.lunchboxUploadArtWorkNotice){
//         Doesn't currently exist
      }

      if (noticeTexts.multipartsUploadArtWorkNotice || noticeTexts.tripleUploadArtWorkNotice){
//         Highlight different boxes??
//         $('.btn--secondary.upload-artwork, .btn--secondary.select-from-library').addClass('warning').focus();
//         $('html, body').animate({
//           scrollTop: $('.btn--secondary.upload-artwork').offset().top
//         }, 300);
      }
      $('.notice').html(noticeText).removeClass('hidden');
      window.scrollTo(0, 0);
    }
    return validated;
  }

  /* Window onload event */
  $(window).load(function() {

    // Load values from URL params if existing
    if (window.getQueryParam('updatecart')) {

      // Properties
      var paramKeys = ['Paper Stock', 'Orientation', 'Sides', 'Rounded Corners', 'Description', 'Envelopes', 'EnvelopeType', 'EnvelopeStock', 'EnvelopePrintingOptions', 'FrontOrFlap', 'EnvelopeDescription'];
      var $elem = null;
      paramKeys.forEach(function(paramKey) {
        var paramVal = window.getQueryParam(paramKey);
        $elem = $('[name="properties[' + paramKey + ']"]');
        if ($elem.attr('type') == 'radio') {
          $elem = $('[name="properties[' + paramKey + ']"][value="' + paramVal + '"]');
          $elem.prop('checked', true);
        } else if (paramVal) {
          if ($elem.attr('type') == 'checkbox') {
            $elem.prop('checked', true);
          } else {
            $elem.val(paramVal);
          }
        }
      });

      // Quantity
      var qty = window.getQueryParam('quantity');
      if (qty > 0) {
        $('#Quantity').val(qty);
      }

      // Set images
      var image = '';
      var index = 0;
      while (image = window.getQueryParam('front_image' + (index + 1))) {
        window.fspUtils.setImageForMultipartProduct(
          index,
          window.fspUtils.cacheAndConvertFileStackUrlToJpg(image),
          $('#upload-part' + index).hasClass('landscape')
        );
        $('#upload-part' + index + ' .image').removeClass('hidden');
        $('#product-image' + index).val(image);
        $('#product-image-client' + index).val(window.getQueryParam('front_image_client' + (index + 1)));
        index++;
      }

      // Trigger change event so that product customizer js recalculates price
      $($('.product-customizer-option')[0]).find('select, input').trigger('change');
    }

  });

  $('#UploadImages').click();
  $('#UploadImages').removeClass('hidden');
})(jQuery, window);